import { render, staticRenderFns } from "./SimpleDonutChart.vue?vue&type=template&id=68611834&"
import script from "./SimpleDonutChart.vue?vue&type=script&lang=js&"
export * from "./SimpleDonutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports